<template>
    <div>
        <loading-custom :loading="loading" />
        <!-- Trigger Button -->
        <div class="d-flex justify-content-end">
            <button
                type="button"
                class="btn btn-sm btn-dark mb-2"
                data-toggle="modal"
                data-target="#addCategory"
            >
                <i class="fa fa-plus"></i>
                เพิ่มหมวดหมู่สินค้า
            </button>
        </div>

        <!-- Modal -->
        <div
            class="modal"
            id="addCategory"
            tabindex="-1"
            role="dialog"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-light">
                        <h5 class="tw-font-bold">
                            เพิ่มหมวดหมู่
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="reset()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <input
                            class="form-control"
                            type="text"
                            placeholder="เพิ่มหมวดหมู่"
                            v-model="form.title"
                        />

                        <div class="text-xs mt-3">
                            ไอคอน:
                        </div>
                        <div
                            class="tw-grid tw-grid-cols-10 tw-justify-self-center"
                        >
                            
                            <div
                                v-for="icon in icons"
                                :key="icon"
                                class="tw-cursor-pointer tw-flex tw-justify-center tw-justify-self-center m-2 p-2 square"
                            >
                                <i
                                    :class="['fa ' + icon, { active: form.icon == icon }]"
                                    class="fa-2x"
                                    @click="selectIcon(icon)"
                                ></i>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-4">
                        <button
                            type="button"
                            data-dismiss="modal"
                            class="btn btn-success w-100"
                            @click="store()"
                        >
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import icons from "./icons.json";

export default {
    props: ["shop"],
    data() {
        return {
            form: {
                title: "",
                icon: ""
            },
            loading: false,
            icons: icons
        };
    },
    watch: {},
    methods: {
        selectIcon(icon) {
            this.form.icon = icon;
        },
        // changeStatus(data, props, value) {
        //     data[props] = value;
        // },
        // getData() {
        //     this.form.product_id = this.productId;
        // },
        onUpdate() {
            this.form = {
                title: "",
                icon: ""
            };
            this.$emit("onUpdate", "success");
        },
        reset() {
            this.form = {
                title: "",
                icon: ""
            };
        },
        async store() {
            this.loading = true;

            await axios
                .post(`/backend/s/${this.shop}/categories`, this.form)
                .then(res => {
                    if (res.data.status == "success") {
                        this.onUpdate();
                    } else if (res.data.status == "error") {
                        this.$swal({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: res.data.message,
                            showConfirmButton: true
                        });
                        this.reset()
                    }
                    this.loading = false;
                })
                .catch(err => {
                    this.$swal({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: res.data.message,
                            showConfirmButton: true
                        }); 
                    this.loading = false;
                    this.reset()
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.active {
    color:blue;
}

.square {
    width: 20pt;
    height: 20pt;
}
</style>
